export enum AnchorPoint {
    Start = 'start',
    End = 'end',
}

export enum AnchorOffsetType {
    TimeSeconds = 'time_seconds',
}

export interface Anchor {
    __uuid: string;
    __expandedPartUuid: string;
    anchor_point: AnchorPoint;
    offset_type: AnchorOffsetType;
    offset_value: number;
}
